module.exports = __webpack_public_path__ + "img/julia scheuber_0452.383687a6.jpg";